import PropTypes from 'prop-types'
import { Media, Row } from 'react-bootstrap'
import Image from 'components/image'

const Author = (props) => {
  var { author, className } = { ...props }

  let name = `${author.firstName} ${author.lastName}`
  if (!author.firstName && !author.lastName) {
    name = author.name
  }
  let jobTitle = author.jobTitle
  if (author.postnominals) {
    jobTitle += `, ${author.postnominals}`
  }
  let altText = `{name} {jobTitle}`

  return (
    <Row className={className}>
      <hr className="mbl" />
      <Media className="col-sm-12">
        <Media.Left>
          {author.photo ? (
            <Image
              alt={altText}
              className="thumbnail-profile"
              src={author.photo.url}
            />
          ) : null}
        </Media.Left>
        <Media.Body>
          <h3 className="mtn mbn pll">{name}</h3>
          <h4 className="mtn mbn pll">{jobTitle}</h4>
          <div
            className="mts mbn pll"
            dangerouslySetInnerHTML={{ __html: author.bio }}
          />
        </Media.Body>
      </Media>
    </Row>
  )
}

Author.propTypes = {
  author: PropTypes.object.isRequired,
  className: PropTypes.string,
}

export default Author
